export default __webpack_public_path__ + "img/filter_none.11d656e7c20908a0a362c21b8e6568e5.jpg";